/**
 * The chosen segment of a status control, so the state reads at a glance: green when shoppers can
 * get it, amber while it's being prepared, grey once it's taken away. Dark text on a tint, because
 * white on the green token is too faint to read.
 */
export const STATUS_TONE = {
  live: 'data-[state=on]:bg-success/25 data-[state=on]:text-foreground data-[state=on]:ring-1 data-[state=on]:ring-success/70',
  preparing:
    'data-[state=on]:bg-warning/35 data-[state=on]:text-foreground data-[state=on]:ring-1 data-[state=on]:ring-warning',
  off: 'data-[state=on]:bg-muted-foreground/25 data-[state=on]:text-foreground data-[state=on]:ring-1 data-[state=on]:ring-muted-foreground/60',
} as const;
